import { render, staticRenderFns } from "./AuthPopup.vue?vue&type=template&id=51239c61&scoped=true&"
import script from "./AuthPopup.vue?vue&type=script&lang=js&"
export * from "./AuthPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51239c61",
  null
  
)

export default component.exports